import { defineMessages } from 'react-intl';

export const messages: {
	noResultsPrimary: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	noResultsSecondaryFilters: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	noResultsPrimary: {
		id: 'dynamic-cards-search-page.no_results_primary',
		defaultMessage: "We couldn't find anything matching your search",
		description: 'Message shown when search request returns no results',
	},
	noResultsSecondaryFilters: {
		id: 'dynamic-cards-search-page.no_results_secondary_some_filters_applied',
		defaultMessage: 'Looks like you have some filters applied. You could try clearing them.',
		description: 'Additional message to prompt users to try searching without filters',
	},
});
